exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".switchButtons .MuiButton-root{text-transform:capitalize;font-size:1.2rem;font-weight:300}@media(max-width: 575px){.switchButtons .MuiButton-root{font-size:1rem}}.switchButtons .MuiButton-root .MuiButton-startIcon{padding-bottom:15px}.switchButtons .MuiButton-root .MuiButton-startIcon svg{width:35px;height:35px;overflow:inherit}@media(max-width: 575px){.switchButtons .MuiButton-root .MuiButton-startIcon svg{width:30px;height:30px}}.switchButtons .MuiFormHelperText-root.Mui-error{color:#f44336}.switchButtons .MuiFormHelperText-contained{margin-left:14px}.switchButtons .MuiFormHelperText-root{font-size:.75rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/Common/SubComponents/SwitchButtons.scss
// module id = 7199
// module chunks = 13